import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { InactiveClinicBanner } from '@/components/InactiveClinicBanner';

/**
 * Mirrors v1's `ClinicLayout` (Clinio/src/App.tsx): persistent sidebar +
 * sticky top bar (search + quick-create) + scrollable content area.
 * Module pages render inside the <Outlet /> via React Router.
 */
export function MainLayout() {
  return (
    <div className="flex h-screen min-h-0 flex-col">
      <div className="flex min-h-0 flex-1">
        <Sidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden bg-page-light dark:bg-page-dark">
          <TopBar />
          <InactiveClinicBanner />
          <div className="flex-1 overflow-y-auto px-8 pb-12 pt-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
